import { categories } from "@/mocks/categories";

export default function Footer() {
  const mainLinks = categories.slice(0, 7);
  const moreLinks = categories.slice(7);

  return (
    <footer className="bg-background-100 pt-16 md:pt-24 pb-8 px-4 md:px-6 lg:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="bg-background-50 rounded-3xl border border-background-200/70 p-6 md:p-10 lg:p-12">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-6">
            <div className="md:col-span-4">
              <a href="/" className="flex items-center gap-2 text-foreground-950 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-leaf-line text-primary-500 text-xl"></i>
                </div>
                <span className="font-heading font-semibold text-lg">Mulebuy Spreadsheet</span>
              </a>
              <p className="text-foreground-600 text-sm leading-relaxed max-w-xs">
                An informational platform focused on educational content around the mulebuy spreadsheet system. We provide structured guides, comparisons, and educational resources.
              </p>
            </div>

            <div className="md:col-span-2">
              <h4 className="font-heading font-semibold text-foreground-950 text-sm uppercase tracking-wide mb-4">
                Categories
              </h4>
              <ul className="space-y-2.5">
                {mainLinks.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-foreground-600 text-sm hover:text-foreground-950 transition-colors"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-2">
              <h4 className="font-heading font-semibold text-foreground-950 text-sm uppercase tracking-wide mb-4">
                More
              </h4>
              <ul className="space-y-2.5">
                {moreLinks.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-foreground-600 text-sm hover:text-foreground-950 transition-colors"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-4">
              <h4 className="font-heading font-semibold text-foreground-950 text-sm uppercase tracking-wide mb-4">
                Resources
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <a href="/blog/what-is-mulebuy-spreadsheet" className="text-foreground-600 text-sm hover:text-foreground-950 transition-colors">
                    Mulebuy Spreadsheet Guide
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-foreground-600 text-sm hover:text-foreground-950 transition-colors">
                    Main Website
                  </a>
                </li>
                <li>
                  <a href="/" className="text-foreground-600 text-sm hover:text-foreground-950 transition-colors">
                    Home
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 text-foreground-500 text-xs">
              <span>&copy; {new Date().getFullYear()} Mulebuy Spreadsheet. All rights reserved.</span>
              <span className="hidden sm:inline">|</span>
              <span>This website provides educational and informational content.</span>
            </div>
            <div className="flex items-center gap-3">
              <a
                href="https://x.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center bg-foreground-950 rounded-full text-white hover:bg-foreground-800 transition-colors"
                aria-label="Twitter / X"
              >
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a
                href="https://instagram.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center bg-foreground-950 rounded-full text-white hover:bg-foreground-800 transition-colors"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}